import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Plus, Pill, Clock, Settings } from 'lucide-react';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { path: '/today', label: 'Today', icon: Home },
    { path: '/add-medication', label: 'Add Med', icon: Plus },
    { path: '/meds', label: 'Meds', icon: Pill },
    { path: '/history', label: 'History', icon: Clock },
    { path: '/settings', label: 'Settings', icon: Settings },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t-4 border-gray-200 bottom-nav safe-area-bottom z-50 w-full" data-testid="bottom-nav">
      <div className="flex justify-around items-center h-20 sm:h-24 px-2 max-w-full">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = location.pathname === tab.path;
          return (
            <button
              key={tab.path}
              data-testid={`nav-${tab.label.toLowerCase().replace(' ', '-')}`}
              onClick={() => navigate(tab.path)}
              className={`flex flex-col items-center justify-center flex-1 h-full touch-target min-w-0 ${
                isActive ? 'text-green-600' : 'text-gray-500'
              }`}
            >
              <Icon size={28} strokeWidth={2.5} className="flex-shrink-0" />
              <span className="text-xs sm:text-sm font-semibold mt-1 truncate max-w-full px-1">{tab.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;